/**
 * Created by Greg on 4/26/2016.
 */
import React from 'react';
import { connect } from 'react-redux'
import {Button, Nav, NavItem, NavDropdown, MenuItem, Modal, FormControl} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {pathValidate} from './../../validation/pathValid';
import $ from 'jquery';

var PathInfo = React.createClass({
    getInitialState(){
        return {groupsSelected: new Set(), view: "collection", groupIndex: null,
            pathsSelected: new Set(), exportString: "", showExportDialog: false};
    },

    onCollectionRowSelect(row, isSelected){
        let groupsSelected = this.state.groupsSelected;
        if (isSelected) {
            groupsSelected.add(row.listId)
            this.setState({groupsSelected: groupsSelected});
        } else {
            groupsSelected.delete(row.listId);
            this.setState({groupsSelected: groupsSelected});
        }
    },

    onCollectionSelectAll(isSelected){
        // console.log("is select all: " + isSelected);
        let groupsSelected = this.state.groupsSelected;
        if (isSelected) {
            for (let i = 0; i < this.props.paths.length; i++) {
                groupsSelected.add(i);
            }
        } else {
            groupsSelected.clear();
        }
        this.setState({groupsSelected: groupsSelected});
    },


    onPathSelected(row, isSelected) {
        let pathsSelected = this.state.pathsSelected;

        if (isSelected) {
            pathsSelected.add(row.id)
            this.setState({pathsSelected: pathsSelected});
        } else {
            pathsSelected.delete(row.id);
            this.setState({pathsSelected: pathsSelected});
        }
        this.props.linkSelect(this.selectedLinks());
    },

    onPathSelectAll(isSelected) {
        let pathsSelected = this.state.pathsSelected;
        if (!isSelected) {
            pathsSelected.clear();
            this.setState({pathsSelected: pathsSelected});
            this.props.linkSelect(this.selectedLinks());
            return;
        }
        // Have to handle the all paths case separate from the specific paths case
        if (this.state.groupIndex === null) {
            for (let i = 0; i < this.props.paths.length; i++) {
                for (let j = 0; j < this.props.paths[i].pathList.length; j++) {
                    pathsSelected.add(i.toString() + "." + j.toString());
                }
            }
        } else {
            for (let j = 0; j < this.props.paths[this.state.groupIndex].pathList.length; j++) {
                pathsSelected.add(j);
            }
        }
        this.setState({pathsSelected: pathsSelected});
        this.props.linkSelect(this.selectedLinks());
    },

    // Returns a list of selected links based on the currently selected paths
    selectedLinks() {
        let links = this.props.net.links;
        let selLinks = [];
        let pathObjs = this.getSelectedPaths();
        for (let p of pathObjs) {
            for (let i = 0; i < p.nodeList.length - 1; i++) {
                // Check if link is in network, if so add it to selection
                let a = p.nodeList[i];
                let b = p.nodeList[i+1];
                if (links.find(l => l.source === a && l.target === b)) {
                    selLinks.push([a, b]);
                }
                if (links.find(l => l.source === b && l.target === a)) {
                    selLinks.push([b, a]);
                }               
            }
        }
        return selLinks;

    },

    // Returns a list of selected path objects, for use in highlighting
    getSelectedPaths() {
        let that = this;
        let selPathObjs = [];
        let pathsSelected = this.state.pathsSelected; // The set of indices from the GUI
        if (this.state.groupIndex === null) { // Working with "all paths"
            pathsSelected.forEach(function(iString){  // iString has the form "1.2"
                let parts = iString.split(".");
                let gIndex = parseInt(parts[0]);
                let pIndex = parseInt(parts[1]);
                selPathObjs.push(that.props.paths[gIndex].pathList[pIndex]);
            });
        } else {
            pathsSelected.forEach(function(i){
                selPathObjs.push(that.props.paths[that.state.groupIndex].pathList[i]);
            })
        }
        return selPathObjs;
    },

    removeSelected() {
        let groupsSelected = this.state.groupsSelected;
        let newPaths = this.props.paths.filter((p, i) => !groupsSelected.has(i));
        groupsSelected.clear();
        this.props.pathsUpdate(newPaths);
        this.setState({groupsSelected: groupsSelected});
    },

    exportSelected() {
        let groupsSelected = this.state.groupsSelected;
        let exportPaths = this.props.paths.filter((p, i) => groupsSelected.has(i));
        if (exportPaths.length === 0) {
            this.setState({exportString: "", showExportDialog: false});
            return; // Nothing to export
        }
        if (exportPaths.length === 1) {
            this.setState({exportString: JSON.stringify(exportPaths[0], null, 2), showExportDialog: true});
        } else {
            let pathGroup = {id: "Multi-Export", desc: "", pathList: []};
            for (let pg of exportPaths) {
                pathGroup.desc += pg.id + ", ";
                pathGroup.pathList.push(...pg.pathList);
            }
            this.setState({exportString: JSON.stringify(pathGroup, null, 2), showExportDialog: true});
        }
    },

    closeExportDialog(){
        this.setState({showExportDialog: false});
    },

    handleTabSelect(eventKey, event) {
        // console.log('Tab handler selected eventKey ' + eventKey);
        // console.log(eventKey);
        let items = eventKey.split(".");
        let pathsSelected = this.state.pathsSelected;
        pathsSelected.clear();
        this.setState({view: items[0], groupIndex: items[1]? parseInt(items[1]) : null, pathsSelected: pathsSelected});
        this.props.linkSelect(this.selectedLinks());
    },

    render: function() {
        let hOffsetCollection = 135;
        let hOffsetPathTables = 110;
        let menuItems = this.props.paths.map((p,i) => <MenuItem key={"specific."+ i} eventKey={"specific."+ i}>{p.id}</MenuItem>);
        let content = null;
        switch (this.state.view) {
            case 'collection':
                let data = prepPathCollections(this.props.paths, this.props.net);
                content = <div>
                    <PathCollectionsTable data={data}  height={this.props.height-hOffsetCollection}
                    sel={this.onCollectionRowSelect} selAll={this.onCollectionSelectAll}
                                  gSelected={[...this.state.groupsSelected]}/>
                <Button bsStyle="info" bsSize="xsmall" onClick={this.removeSelected}>Remove Selected</Button>
                    <Button bsStyle="primary" bsSize="xsmall" onClick={this.exportSelected}>Export Selected</Button>
                </div>
                break;
            case 'allPaths':
                content = <AllPathsTable paths={this.props.paths} net={this.props.net}
                                         pSelected={[...this.state.pathsSelected]}
                                         selAll={this.onPathSelectAll}
                                         sel={this.onPathSelected} height={this.props.height- hOffsetPathTables}/>;
                break;
            case 'specific':
                content = <PathGroupTable pathGroup={this.props.paths[this.state.groupIndex]}
                                          pSelected={[...this.state.pathsSelected]}
                                          selAll={this.onPathSelectAll}
                                          sel={this.onPathSelected}
                                          net={this.props.net} height={this.props.height-hOffsetPathTables} />;
                break;
        }

        return <div id="PathInfo">
            <Nav bsStyle="tabs" activeKey={this.state.view} onSelect={this.handleTabSelect}>
            <NavItem eventKey="collection" href="/home">Manage Path Groups</NavItem>
        <NavItem eventKey="allPaths" title="Item">All Paths</NavItem>
        <NavDropdown eventKey="specific" title="Specific Group" id="nav-dropdown">
            {menuItems}
        </NavDropdown>
      </Nav>
            {content}

            <Modal show={this.state.showExportDialog} onHide={this.closeExportDialog} dialogClassName="export-path-modal" >
            <Modal.Header closeButton>
                <Modal.Title>Selected Path Groups JSON</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                <FormControl componentClass="textarea" readOnly value={this.state.exportString} rows={10} style={{resize: "none"}}/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.closeExportDialog} >Close</Button>
            </Modal.Footer>
            </Modal>


        </div>;
    }

});

var AllPathsTable = React.createClass({
    // Create the data to show in the table.
    createData(paths, net) {
        let data = [];
        let groupIndex = 0;
        let attrs = ["nodeList"];
        let attrMap = new Map();
        // Get the attributes of all the path groups
        for (let group of paths) {
            [attrs, attrMap] = pathAttr(group.pathList, attrs, attrMap);
        }
        for (let group of paths) {
            let groupName = group.id;
            let pathIndex = 0;
            for (let path of group.pathList) {
                let p = {id: groupIndex.toString() + "." + pathIndex.toString(),
                    src: path.nodeList[0], trg: path.nodeList[path.nodeList.length-1],
                    nodeList: path.nodeList.join(", "),
                    compat: pathValidate(path, net).valid, gName: groupName};
                for (let i = 1; i < attrs.length; i++) {
                    p[attrs[i]] = path[attrs[i]];
                }
                data.push(p);
                pathIndex++;
            }
            groupIndex++;
        }
        return [data, attrs];
    },

    render: function () {
        let [data, attrs] = this.createData(this.props.paths, this.props.net);
        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            bgColor: "rgb(238, 193, 213)",
            onSelect: this.props.sel,
            onSelectAll: this.props.selAll,
            selected: this.props.pSelected
        };

        let extraCols = [];
        for (let i = 1; i < attrs.length; i++) {
            extraCols.push(<TableHeaderColumn dataField={attrs[i]} key={attrs[i]} dataSort={true}
                            dataFormat={cellFormater} width="60">{capitalize(attrs[i])}</TableHeaderColumn>)
        }
        return (
            <BootstrapTable data={data} striped={true} keyField="id"
                            trClassName={function(row){if (!row.compat) return "nonCompatible";}}
                            condensed={true} selectRow={selectRowProp}
                            height={this.props.height.toString()}>
                <TableHeaderColumn dataField="gName" key={"gName"} dataSort={true}
                                   width="80">Group</TableHeaderColumn>
                <TableHeaderColumn dataField="src" key={"src"} dataSort={true}
                                   width="60">Start</TableHeaderColumn>
                <TableHeaderColumn dataField="trg" key={"trg"} dataSort={true}
                                   width="60">End</TableHeaderColumn>
                <TableHeaderColumn dataField="nodeList" key={"nodeList"}
                                   dataSort={true}
                                   columnClassName="multiLineTableEntry"
                                   width="150">Node List</TableHeaderColumn>
                {extraCols}
            </BootstrapTable>);
    }
})

var PathGroupTable = React.createClass({
    // Create the data to show in the table.
    createData(pathGroup, net) {
        let data = [];
        let index = 0;
        let attrs, attrMap;
        [attrs, attrMap] = pathAttr(pathGroup.pathList);
        for (let path of pathGroup.pathList) {
            let p = {id: index, src: path.nodeList[0], trg: path.nodeList[path.nodeList.length-1],
                    nodeList: path.nodeList.join(", "), compat: pathValidate(path, net).valid};
            for (let i = 1; i < attrs.length; i++) {
                p[attrs[i]] = path[attrs[i]];
            }
            data.push(p);
            index++;
        }
        return [data, attrs];
    },

    render: function () {
        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            bgColor: "rgb(238, 193, 213)",
            onSelect: this.props.sel,
            onSelectAll: this.props.selAll,
            selected: this.props.pSelected
        };

        let [data, attrs] = this.createData(this.props.pathGroup, this.props.net);
        // console.log(this.props.pSelected);
        let extraCols = [];
        for (let i = 1; i < attrs.length; i++) {
            extraCols.push(<TableHeaderColumn dataField={attrs[i]} key={attrs[i]} dataSort={true}
                            dataFormat={cellFormater} width="60">{capitalize(attrs[i])}</TableHeaderColumn>)
        }
        return (
            <BootstrapTable data={data} striped={true} keyField="id"
                            condensed={true} selectRow={selectRowProp}
                            trClassName={function(row){if (!row.compat) return "nonCompatible";}}
                            height={this.props.height.toString()}>
                <TableHeaderColumn dataField="src" key={"src"} dataSort={true}
                                   width="60">Start</TableHeaderColumn>
                <TableHeaderColumn dataField="trg" key={"trg"} dataSort={true}
                                   width="60">End</TableHeaderColumn>
                <TableHeaderColumn dataField="nodeList" key={"nodeList"}
                                   dataSort={true}
                                   columnClassName="multiLineTableEntry"
                                   width="150">Node List</TableHeaderColumn>
                {extraCols}
            </BootstrapTable>);
    }
})

/*
 Extracts the path attributes in addition to nodeList.
 paths is an array of path objects.
 */
function pathAttr(paths, pathAttr=["nodeList"], attrMap = null) {
    if (!attrMap ) {
        attrMap = new Map();  // Set up a map to take us from attribute to formating type.
    }
    // Get all the link attributes used on paths other than nodeList
    let path, attr;
    for (let i = 0; i < paths.length; i++) {
        path = paths[i];
        for (attr in path) {
            if (path.hasOwnProperty(attr)) {
                if (pathAttr.indexOf(attr) === -1) { // not already in the attribute list
                    pathAttr.push(attr);
                    if (!attrMap.has(attr)) {
                        attrMap.set(attr, typeof path[attr]);
                    }
                }
            }
        }
    }
    return [pathAttr, attrMap];
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function cellFormater(cell, row) {
    if (typeof cell === 'number') {
        return cell.toPrecision(4);
    } else {
        return cell;
    }
}

var PathCollectionsTable = React.createClass({

    render: function () {
        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            bgColor: "rgb(238, 193, 213)",
            onSelect: this.props.sel,
            onSelectAll: this.props.selAll,
            selected: this.props.gSelected
        };
        return (<BootstrapTable data={this.props.data} striped={true}  keyField="listId"
                                condensed={true} selectRow={selectRowProp}
                                height={this.props.height.toString()}>
            <TableHeaderColumn dataField="id" key={"id"} dataSort={true} width="100">Name</TableHeaderColumn>
            <TableHeaderColumn dataField="desc" key={"desc"} dataSort={true} columnClassName="multiLineTableEntry" width="150">Description</TableHeaderColumn>
            <TableHeaderColumn dataField="num" key={"num"} dataSort={true} width="75">Number</TableHeaderColumn>
            <TableHeaderColumn className="multiLineTableEntry" dataField="numCompat" key={"numCompat"} dataSort={true} >Number Compatible</TableHeaderColumn>
      </BootstrapTable>);
    }

})

// Paths is a list of path collection objects
function prepPathCollections(paths, net) {
    if (paths.length === 0) {
        return [];
    }
    let data = paths.map(function(pc, i){
        let pcData = {listId: i, id: pc.id, desc: pc.desc, num: pc.pathList.length};
        // Compute how many paths in the collection are compatible with the network
        let compatible = 0;
        for (let path of pc.pathList) {
            if (pathValidate(path, net).valid) {
                compatible++;
            }
        }
        pcData.numCompat = compatible;
        return pcData;
    });
    return data;
}

const mapStateToProps = (state) => {
    return {
        net: state.net,
        paths: state.paths,
        netVisInteract: state.netVisInteract
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        pathsUpdate: (paths) => {
            dispatch({type: 'PATHS_UPDATE', paths: paths});
        },
        linkSelect: (selectedLinks) => {
            dispatch({type: 'BULK_LINK_SELECT', selectedLinks: selectedLinks});
        }
    };
};

export const PathInfoContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(PathInfo)



// WEBPACK FOOTER //
// ./src/info/PathInfo.js